import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Absence} from './resource/absence';
import {BaseService} from '../../core/service/base.service';
import {Observable} from 'rxjs';
import {HeaderConstants} from '../../core/utils/headers.constants';
import {FileResource} from '../../model/file';
import {PaidLeavesFilter} from './filter/paid-leaves.filter';

@Injectable()
export class AbsenceService extends BaseService<Absence> {

  serviceUrl(): string {
    return `/api/t/{tenant}/absences`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }

  getAttachments(id: number): Observable<FileResource[]> {
    return this.http
      .get<FileResource[]>(`${this.serviceUrl()}/${id}/attachment`);
  }

  deleteAttachment(id: number, attachmentId: number): Observable<any> {
    return this.http
      .delete(`${this.serviceUrl()}/${id}/attachment/${attachmentId}`);
  }

  uploadAttachments(formData: FormData, budgetFormId: number): Observable<any> {
    return this.http.post<any>(`${this.serviceUrl()}/${budgetFormId}/attachment`, formData, {
      headers: new HttpHeaders().set(HeaderConstants.IGNORE_CONTENT_TYPE, 'true')
    });
  }
  downloadAttachment(id: number, attachmentId: number): Observable<any> {
    return this.http.get(`${this.serviceUrl()}/${id}/attachment/${attachmentId}`, {responseType: 'blob'});
  }

  exportPaidLeaves(filter: PaidLeavesFilter): Observable<any> {
    return this.http.post(`${this.serviceUrl()}/paid/export`, JSON.stringify(filter), {responseType: 'blob'});
  }

  savePeriod(model: Absence): Observable<Absence> {
    console.info('Creating', JSON.stringify(model));
    return this.http
      .post<Absence>(`${this.serviceUrl()}/period`, JSON.stringify(model));
  }

  exportPaidVacations(employeeId: number, from: string, to: string): Observable<any> {
    const params = new HttpParams()
      .set('from', from)
      .set('to', to);

    return this.http.get(`${this.serviceUrl()}/employees/${employeeId}/paid/export`, {
      params,
      responseType: 'blob'
    });
  }
}
